import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';
import {Subject, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {PersonaGiuridicaDTO} from '../../../models/persona-giuridica-dto';
import {ComponentOutputStatus} from '../../../normalizzazione/component-output-status';
import {MessageService} from '../../../services/message.service';
import {ValidationService} from '../../../services/validation.service';

@Component({
	selector: 'lib-pg',
	templateUrl: './pg.component.html',
	styleUrls: ['./pg.component.css']
})
export class PgComponent implements OnInit, OnDestroy {

	form: FormGroup;

	@Input()
	resetForm: Subject<boolean>;

	@Input()
	showRagioneSociale: boolean = true;

	@Input()
	showPartitaIVA: boolean = true;

	@Output()
	done: EventEmitter<ComponentOutputStatus<PersonaGiuridicaDTO>> = new EventEmitter<ComponentOutputStatus<PersonaGiuridicaDTO>>();

	subscription: Subscription;


	constructor(public msg: MessageService) {
	}

	ngOnInit(): void {

		this.form = new FormGroup({});

		if (this.resetForm) {
			this.subscription = this.resetForm.subscribe(val =>
				val ? this.pulisciForm() : "");
		}

		const codiceFiscale = new FormControl(
			{value: '', disabled: false},
			//TOLTO controllo per dare la possiibilità di inserimento anche della ditta individuale
			// [
			// 	// Validators.required,
			// 	ValidationService.pattern(
			// 		ValidationService.partitaIva,
			// 		"partitaIVAInvalida"
			// 	),
			// ]
			[ValidationService.pattern(
					ValidationService._codiceFiscalePiva,
					"cfInvalidoFormalmente"
				)
			]
		);
		this.form.addControl("codiceFiscale", codiceFiscale);

		if (this.showRagioneSociale) {
			const ragioneSociale = new FormControl(
				{value: '', disabled: false},
				// [
				// 	Validators.required
				// ]
			);

			this.form.addControl("ragioneSociale", ragioneSociale);
		}

		if (this.showPartitaIVA) {
			const partitaIVA = new FormControl(
				{value: '', disabled: false},
				[
					// Validators.required,
					ValidationService.pattern(
						// ValidationService.partitaIvaMaxLen2,
						// "partitaIVAMaxLen2"
						ValidationService.partitaIva,
						"partitaIVAInvalida"
					),
				]
			);
			this.form.addControl("partitaIVA", partitaIVA);
		}

		const changes$ = this.form.valueChanges.pipe(
			map((_) => {
				const newSocieta = new PersonaGiuridicaDTO();
				newSocieta.codiceFiscale = this.form.controls["codiceFiscale"].value;
				newSocieta.ragioneSociale = this.form.controls["ragioneSociale"]?.value;
				newSocieta.partitaIVA = this.form.controls["partitaIVA"]?.value;
				return ComponentOutputStatus.of(this.form.valid, newSocieta);
			})
		);

		this.form.setValidators(form => {
			return (
				!form.get('codiceFiscale').value && (this.showPartitaIVA && !form.get('partitaIVA').value)
			) ?
				{requiredPG: true}
				: null;
		});

		this.subscription = changes$.subscribe((_) => this.done.emit(_));
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	pulisciForm() {
		const keys = Object.keys(this.form.value);
		keys.forEach(key => {
			const control: AbstractControl = this.form.get(key);
			control.setValue("");
		});
	}

}
